module.exports = __webpack_public_path__ + "static/img/b1.ad73cf7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bussiness/b1.jpg
// module id = 49ou
// module chunks = 1